import Moment from 'moment';
// import { isWithin30Days } from '../helpers/time-helpers';

//Simplifi Price Warnings
// const expiredDatePast = expireOn => {
//   const diff = Moment('May 31 2022', 'MMMM DD YYYY').diff(Moment(expireOn), 'days');
//   return diff;
// };

export const getSimpPriceWarning = (sku, expireOn, featureFlags) => {
  const EMAIL_SENT = featureFlags?.q4_2024_simplifi_price_email_sent || false;
  const ENABLE_PRICE_OVERRIDE = featureFlags?.q4_2024_simplifi_price_overrides || false;

  const expireTargetStart = Moment('2024-10-20', 'YYYY-MM-DD');
  const expireTargetEnd = Moment('2024-12-01', 'YYYY-MM-DD');
  const IN_EXPIRY_RANGE = Moment(expireOn).isBetween(expireTargetStart, expireTargetEnd, undefined, '[]');

  const MONTHLY_WARNING_SKUS = [];
  const MONTHLY_NEW_PRICE = false;
  const IS_APPLICABLE_MONTHLY = MONTHLY_WARNING_SKUS.includes(sku);

  const ANNUAL_WARNING_SKUS = ['170313', '170421', '170298', '170333', '170419', '170296', '170325', '170368'];
  const ANNUAL_NEW_PRICE = '$71.88';
  const IS_APPLICABLE_ANNUAL = ANNUAL_WARNING_SKUS.includes(sku);

  const HAS_PRICE_WARNING = ((IS_APPLICABLE_ANNUAL || IS_APPLICABLE_MONTHLY) && ENABLE_PRICE_OVERRIDE && IN_EXPIRY_RANGE && EMAIL_SENT);
  const NEW_PRICE = IS_APPLICABLE_ANNUAL ? ANNUAL_NEW_PRICE : MONTHLY_NEW_PRICE;

  return {
    HAS_PRICE_WARNING: HAS_PRICE_WARNING,
    NEW_PRICE: NEW_PRICE,
    productLineUriName: 'acme'
  };
};
//End Simplifi Price Warnings




//Quicken US Price Warnings
export const usPriceWarnings = (tierUriName, expireOn) => {
  const expiryDate = Moment(expireOn);
  const oldPrices = {
    'starter': '$47.88',
    'deluxe': '$71.88',
    'premier': '$95.88',
    'deluxe-standard-fp': '$71.88',
    'deluxe-flex-fp': '$71.88',
    'premier-standard-fp': '$95.88',
    'premier-flex-fp': '$95.88',
    'hab-rpm': '$131.88',
    'hab-standard-fp': '$131.88',
    'hab-flex-fp': '$131.88'
  };

  const newPrices = {
    'starter': '$53.88',
    'deluxe': '$77.88',
    'premier': '$101.88',
    'hab-rpm': '$143.88',

    'deluxe-standard-fp': '$77.88',
    'deluxe-flex-fp': '$77.88',
    'premier-standard-fp': '$101.88',
    'premier-flex-fp': '$101.88',
    'hab-standard-fp': '$143.88',
    'hab-flex-fp': '$143.88'
  };


  const dateConstants = {
    WAVE1_EXP_START: Moment('2025-07-01', 'YYYY-MM-DD'),
    WAVE1_EXP_END: Moment('2025-07-30', 'YYYY-MM-DD'),
    WAVE1_WARN_START: Moment('2025-06-01', 'YYYY-MM-DD'),
    WAVE1_WARN_END: Moment('2025-6-30', 'YYYY-MM-DD'),
  };

  let WARNING_START = false;
  let WARNING_END = false;
  let WARN_WAVE = '';

  if (expiryDate.isBetween(dateConstants.WAVE1_EXP_START, dateConstants.WAVE1_EXP_END, undefined, '[]')) {
    WARNING_START = dateConstants.WAVE1_WARN_START;
    WARNING_END = dateConstants.WAVE1_WARN_END;
    WARN_WAVE = 'WAVE1';
  }

  const CUR_DATE = Moment().format('YYYY-MM-DD');
  const WARNING_TIERS = Object.keys(newPrices);
  const IS_WARNING_TIER = WARNING_TIERS.includes(tierUriName);
  // date inclusive, don't remove the undefined/empty array
  const WARNING_ACTIVE = ((WARNING_START && WARNING_END) && Moment(CUR_DATE).isBetween(WARNING_START, WARNING_END, undefined, '[]'));
  const PRICE_WARNING = (IS_WARNING_TIER && WARNING_ACTIVE);

  // const debugData = {
  //   WARNING_START: WARNING_START,
  //   WARNING_END: WARNING_END,
  //   CUR_DATE: CUR_DATE,
  //   IS_WARNING_TIER: IS_WARNING_TIER,
  //   WARNING_ACTIVE: WARNING_ACTIVE,
  //   HAS_PRICE_UPDATE: PRICE_WARNING,
  //   WARN_WAVE: WARN_WAVE,
  //   PRICE: (WARN_WAVE == 'WAVE1') ? newPrices[tierUriName] : oldPrices[tierUriName],
  //   expireOn: expireOn
  // };
  // console.log(Moment(CUR_DATE).isBetween(WARNING_START, WARNING_END, undefined, '[]'));
  // console.log(debugData);

  return {
    HAS_PRICE_UPDATE: PRICE_WARNING,
    WARN_WAVE: WARN_WAVE,
    WARNING_START: WARNING_START,
    PRICE: newPrices[tierUriName],
    expireOn: expireOn,
    NEW_PRICE_LIST: newPrices,
    productLineUriName: 'quicken-us'
  };
};

export const caPriceWarnings = (tierUriName, expireOn) => {
  const expiryDate = Moment(expireOn);

  const oldPricesCa = {
    'cash-manager': '$53.88',
    'starter': '$53.88',
    'deluxe': '$83.88',
    'hab': '$119.88',
  };

  const newPricesCa = {
    'cash-manager': '$65.88',
    'starter': '$65.88.',
    'deluxe': '$101.88',
    'hab': '$143.88',
  };

  const dateConstants = {
    WAVE1_START: Moment('2025-10-01', 'YYYY-MM-DD'),
    WAVE1_END: Moment('2025-10-30', 'YYYY-MM-DD'),
    WAVE1_WARN_START: Moment('2025-09-01', 'YYYY-MM-DD'),
    WAVE1_WARN_END: Moment('2025-09-30', 'YYYY-MM-DD'),
  };

  let WARNING_START = false;
  let WARNING_END = false;
  let WARN_WAVE = '';

  if (expiryDate.isBetween(dateConstants.WAVE1_START, dateConstants.WAVE1_END, undefined, '[]')) {
    WARNING_START = dateConstants.WAVE1_WARN_START;
    WARNING_END = dateConstants.WAVE1_WARN_END;
    WARN_WAVE = 'WAVE1';
  }

  const CUR_DATE = Moment().format('YYYY-MM-DD');
  const WARNING_TIERS = Object.keys(newPricesCa);
  const IS_WARNING_TIER = WARNING_TIERS.includes(tierUriName);
  const WARNING_ACTIVE = (
    (WARNING_START && WARNING_END) &&
    // date inclusive, don't remove the undefined/empty array
    Moment(CUR_DATE).isBetween(WARNING_START, WARNING_END, undefined, '[]')
  );
  const PRICE_WARNING = (IS_WARNING_TIER && WARNING_ACTIVE);

  // Set localstorage key for QA in stage/dev only
  if(['development', 'staging'].includes(process.env.REACT_APP_ENV)) {
    localStorage.setItem('priceChange', JSON.stringify({
      usrSubData: {
        tierUriName: tierUriName,
        expireOn: expireOn
      },
      conditions: {
        HAS_PRICE_UPDATE: PRICE_WARNING,
        WARN_WAVE: WARN_WAVE,
        WARNING_START: WARNING_START,
        WARNING_END: WARNING_END,
        PRICE: (WARN_WAVE == 'WAVE1') ? newPricesCa[tierUriName] : oldPricesCa[tierUriName],
        OLD_PRICE: oldPricesCa[tierUriName],
        NEW_PRICE: newPricesCa[tierUriName],
      }
    }));
  }

  return {
    HAS_PRICE_UPDATE: PRICE_WARNING,
    WARN_WAVE: WARN_WAVE,
    WARNING_START: WARNING_START,
    WARNING_END: WARNING_END,
    PRICE: (WARN_WAVE == 'WAVE1') ? newPricesCa[tierUriName] : oldPricesCa[tierUriName],
    OLD_PRICE: oldPricesCa[tierUriName],
    NEW_PRICE: newPricesCa[tierUriName],
    expireOn: expireOn,
    productLineUriName: 'quicken-ca'
  };
};



export const getQknPriceWarn = (tierUriName, expireOn, country) => {
  if(country === 'ca') {
    return caPriceWarnings(tierUriName, expireOn);
  } else {
    return usPriceWarnings(tierUriName, expireOn);
  }
};
//End Quicken Price Warnings

